import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type WorkspaceNavigationItemInfoFragment = { __typename?: 'Workspace', id: string, name: string, images?: { __typename?: 'Images', image128?: string | null } | null };

export const WorkspaceNavigationItemInfo = /*#__PURE__*/ gql`
    fragment WorkspaceNavigationItemInfo on Workspace {
  id
  name
  images {
    image128
  }
}
    ` as unknown as DocumentNode<WorkspaceNavigationItemInfoFragment, unknown>;

        

        
export const useWorkspaceNavigationItemInfoFragment = (
  input: string | Omit<UseFragmentOptions<WorkspaceNavigationItemInfoFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Workspace' } };
    return input;
  })();

  return useFragment<WorkspaceNavigationItemInfoFragment>({
    fragment: WorkspaceNavigationItemInfo,
    fragmentName: 'WorkspaceNavigationItemInfo',
    ...options,
  });
};
  
        